import React, { memo } from 'react';

import scss from './CardWrapper.module.scss';

export const EDIT_PROJECT_SECTION = {
  NAME: 'name',
  SHARE: 'share',
  FILE: 'file',
  ASSIGNED_USERS: 'users',
  ASSIGNED_ASSISTANTS: 'assistants',
  AGENT: 'agent',
};

const CardWrapper = ({ label, children, sectionType }) => {
  return (
    <div className={scss.wrapper} style={{ gridArea: sectionType }}>
      <h3 className={scss.title}>{label}</h3>
      <div className={scss.content}>{children}</div>
    </div>
  );
};

export default memo(CardWrapper);
